/* ---------------------------------------

    -- スクロール連動はここ

--------------------------------------- */
export default class Pararax{
    constructor(){
        this.$prarax;
        this.start = true;/* trueで処理が開始される */
        this.scInc = 0;
        this.paraPoint = [];
        this.paraNum;


        this.prevDir = "";/* scrollManagerから引き継いだ方向を保存する */

        /*  ステータスをセット */
        this.status = [];

        this.deviceSize = "";
        this.deviceRate = 1;

        this.renderTime = 0


    }
    init(winH){
        this.$prarax = document.querySelectorAll('.js__psc');
        this.paraNum = this.$prarax.length;

        for(var i=0; this.paraNum>i; i++){
            var $p = this.$prarax[i];

            this.status[i] = {
                rate : $p.getAttribute('data-rate'),
                type : ""
            }
            let _t;
            for(let j=0; j < $p.classList.length; j++){
                if($p.classList[j].match(/js__/g))  _t = $p.classList[j].replace("js__","");
                this.status[i].type = _t;
            }
        }
        this.resize(winH)
    }
    check(inc,dir){
        if(!this.start) return;

        this.renderTime +=1
        if(this.renderTime<4) return
        this.renderTime = 0


        let i = 0;
        while(i < this.paraNum){
            // if(this.$prarax[i].nodeType!=1) break; // dom要素以外は処理止める
            // if(this.paraPoint[i]===undefined) return;
            if(this.paraPoint[i].start < inc && this.paraPoint[i].end > inc  ) {
                var $p = this.$prarax[i];

                var pInc = ( inc - this.paraPoint[i].base ) * this.status[i].rate;

                switch (this.status[i].type){
                    case "dir-y":
                        TweenLite.set($p,{
                            "y":-pInc
                        });
                        break;
                    case "dir-y-minus":
                        TweenLite.set($p,{
                            "y":pInc
                        });
                        break;
                    case "type-town":
                        // let _inc = pInc*Math.sin(pInc/20);
                        TweenLite.set($p,{
                            "y":pInc,
                            // "x":_inc
                        });
                        break;
                    case "type-bike":
                        // let _inc = pInc*Math.sin(pInc/20);
                        if(this.prevDir===""||this.prevDir!==dir){
                            for(var j=0; this.paraNum>j; j++){
                                this.$prarax[j].classList.remove("is-"+this.prevDir);
                                this.$prarax[j].classList.add("is-"+dir);
                            }
                        }
                        // console.log($p.classList,dir)
                        this.prevDir = dir;
                        TweenLite.set($p,{
                            "y":pInc,
                            // "x":_inc
                        });
                        break;
                    case "type-cloud":
                        // let _zInc = Math.sin(inc/300)/6;
                        TweenLite.set($p,{
                            "y":-pInc*2,
                            // "z":_zInc
                            // "x":_inc
                        });
                        break;
                    default :
                        TweenLite.set($p,{
                            "x":-pInc/2
                        });
                        break;
                }

            }
            i += 1
        }
    }

    resize (winH,deviceSize) {
        this.deviceRate = deviceSize=="pc" ? 1 : 0.4;
        this.paraPoint = [];
        for (var i = 0; i < this.paraNum; i++) {
            let $p = this.$prarax[i],
                rect =  $p.getBoundingClientRect();
            this.paraPoint[i] = {
                // base  : deviceSize=="pc"?rect.top : rect.top + this.scInc,
                // start : deviceSize=="pc"?Math.max(0,rect.top + this.scInc - winH) : rect.top + this.scInc - winH*1.5,
                // end   : deviceSize=="pc"?rect.top + this.scInc + winH : rect.top + this.scInc + winH*1.5,
                base  : deviceSize=="pc"?rect.top : rect.top,
                start : deviceSize=="pc"?Math.max(0,rect.top + this.scInc - winH) : rect.top + this.scInc - winH*1.5,
                end   : deviceSize=="pc"?rect.top + this.scInc + winH : rect.top + this.scInc + winH*1.5,
            }

            this.status[i].rate = $p.getAttribute('data-rate') * this.deviceRate;

        }
    }


}